import {configureStore} from '@reduxjs/toolkit';
import applicationProcessReducer from './slices/application-process.slice';
import {
  formReducer,
  formStateReducer,
  formAnswersReducer,
  formConfigReducer
} from './slices/general-form.slice.js';

const store = configureStore({
    reducer: {
        applicationProcess: applicationProcessReducer,
        form: formReducer,
        formState: formStateReducer,
        formAnswers: formAnswersReducer,
        formConfig: formConfigReducer
    },
});

export default store;